<tt-email-grid *ngIf="!!get" rememberId="w_orderhead_email_grid" webpage="orderhead" argType="order_internal_no" [argValue]="get.order_internal_no"></tt-email-grid>
